import React from "react";
import DashboardLayout from "../../Components/Common/DashboardLayout";
import ReportComponent from "../../Components/Pages/NCPro/ReportComponent";

export default function View() {

    const content = {
        label: "8D report",
        component: <ReportComponent />
    }

    return (
        <DashboardLayout content={content} />
    );
};